export default {
  text: '#2b2b2b',
  primary: '#fdb83b',
  secondary: '#ffc107',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#383838'
}
